export default class SocketEvents {
    static DOCUMENT_CHANGED_BY_ADMINISTRATOR = "documentChangedByAdministrator";
    static USER_CHANGED_BY_ADMINISTRATOR = "userChangedByAdministrator";
    static FOND_CHANGED_BY_ADMINISTRATOR = "fondChangedByAdministrator";
    static INFO_SETTINGS_CHANGED_BY_ADMINISTRATOR = "infoSettingsChangedByAdministrator";
}